import { render } from "./Vue2Pdf.vue?vue&type=template&id=a5dbbe42"
import script from "./Vue2Pdf.vue?vue&type=script&lang=js"
export * from "./Vue2Pdf.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__